// extracted by mini-css-extract-plugin
export default {"Container":"communications_Container__3-Rxk"};